import { useQuery } from './api'
import { useAuth } from './useAuth'

export function useUserExtendedData() {
  const { isAuthenticated } = useAuth()
  return useQuery('/user--extended-data', undefined, {
    enabled: isAuthenticated,
  })
}
